import _defineProperty from '../../../node_modules/@babel/runtime/helpers/defineProperty.js';
import _objectWithoutProperties from '../../../node_modules/@babel/runtime/helpers/objectWithoutProperties.js';
import PropTypes from 'prop-types';
import { Label, FormHelp } from '@zillow/constellation';
import { int as _int } from '../../../parsers.js';
import { int as _int$1 } from '../../../formatters.js';
import LabeledInputField from '../../common/LabeledInputField.js';
import jsxRuntime from '../../../node_modules/react/jsx-runtime.js';

var _excluded = ["labelText", "helpText"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var getNumericFieldRegisterProps = function getNumericFieldRegisterProps(errMessage) {
  return {
    validate: function validate(v) {
      var parsedVal = _int(v);
      if (parsedVal === null || parsedVal < 0) {
        return errMessage;
      }
      return true;
    },
    setValueAs: function setValueAs(v) {
      return _int(v) || v;
    },
    onBlur: function onBlur(e) {
      var formattedVal = _int$1(e.target.value);
      if (formattedVal) {
        e.target.value = formattedVal;
      }
    }
  };
};
var NumericField = function NumericField(_ref) {
  var labelText = _ref.labelText,
    helpText = _ref.helpText,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsxRuntime.jsx(LabeledInputField, _objectSpread({
    inputMode: "numeric",
    pattern: "[0-9,.]*",
    "aria-label": labelText,
    renderLabel: function renderLabel(labelProps) {
      return /*#__PURE__*/jsxRuntime.jsx(Label, _objectSpread(_objectSpread({}, labelProps), {}, {
        children: labelText
      }));
    },
    description: helpText && /*#__PURE__*/jsxRuntime.jsx(FormHelp, {
      children: helpText
    })
  }, restProps));
};
NumericField.propTypes = {
  labelText: PropTypes.string.isRequired,
  helpText: PropTypes.string
};
var NumericField$1 = NumericField;

export { NumericField$1 as default, getNumericFieldRegisterProps };
//# sourceMappingURL=NumericField.js.map
